import { Action, Dispatch } from 'redux'
import { initShopAction } from 'reducks/shop/actions'

const initShop = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initShopAction())
  }
}

export default initShop
